// src/Auth.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { getStoredAdmin, getStoredToken } from './config/api';

export function RequireAuth({ children }) {
  const admin = getStoredAdmin();
  const token = getStoredToken();
  return admin && token ? children : <Navigate to="/login" replace />;
}

export function RequireRole({ roles = [], children, fallbackTo = '/dashboard' }) {
  const admin = getStoredAdmin();
  const token = getStoredToken();

  if (!admin || !token) {
    return <Navigate to="/login" replace />;
  }

  const allowed = Array.isArray(roles) ? roles : [];
  if (!allowed.length) {
    return children;
  }

  const adminRole = String(admin?.role || '').trim().toLowerCase();
  const hasAccess = allowed.some((role) => String(role || '').trim().toLowerCase() === adminRole);

  return hasAccess ? children : <Navigate to={fallbackTo} replace />;
}

export function useAdmin() {
  return getStoredAdmin();
}
